var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { clientErrorFromResponse } from "../errors.js";
import { attemptSignInWithEmailAddress } from "./sign-in.js";
import { RefreshToken, UserAuthState, getUserRefreshTokenPath, } from "./auth-state.js";
/**
 * Attempts to sign up a user with their email address. To complete the sign-up flow,
 * call `completeSignUpWithEmailLink` and pass the needed information
 */
export const attemptSignUpWithEmailAddress = attemptSignInWithEmailAddress;
// internal function to sign the user up
export function signUpWithFirebaseToken(identity, idtoken, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        let endpoint = new URL("/v1/auth/user/create", identity.baseUrl);
        const res = yield fetch(endpoint, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${idtoken}`,
            },
            mode: "cors",
            body: JSON.stringify(payload),
        });
        const body = yield res.json();
        if (!res.ok) {
            throw clientErrorFromResponse(res.status, body);
        }
        const out = body;
        if (out.data.session) {
            const sess = UserAuthState.fromToken(out.data.session.token);
            // stores the session information
            identity.saveAuthState({
                session: sess,
                refreshTokenPath: getUserRefreshTokenPath(sess),
                refreshToken: out.data.refresh_token
                    ? RefreshToken.fromRefreshJWT(out.data.refresh_token)
                    : null,
            });
        }
        return;
    });
}
